import moment from 'moment';
import { IImportCourse, ICourse } from 'types';

// returns earliest valid course start date
export function getEarliestCourseStartDate(courses: Array<ICourse> | Array<IImportCourse>): moment.Moment | null {
  if ((courses?.length ?? 0) === 0) return null;

  let winningDate: moment.Moment | null = null;
  for (let i = 0; i < courses.length; i++) {
    if (!courses[i]) {
      continue;
    }
    const challengerDate = moment(courses[i].startDate, 'YYYY-MM-DD', true);
    if (challengerDate.isValid() && (winningDate === null || challengerDate.isBefore(winningDate))) {
      winningDate = challengerDate;
    }
  }
  return winningDate;
}
